import type {
  Companies,
  CompaniesListParam,
  CompanyPayload,
  CursorPaginatedResponse,
} from '@/libs/interfaces'

import { MOCK_ORG_ID, mockCompanies } from '../fixtures/seed'
import { delay, matchesSearch, nowISO, paginate } from '../helpers'
import { createEntityStore } from '../store'

const companyStore = createEntityStore<Companies, 'companyOrgNumber'>(
  mockCompanies,
  'companyOrgNumber',
)

const filterCompanies = (params: CompaniesListParam): Companies[] =>
  companyStore
    .getAll()
    .filter((company) => matchesSearch(company, params.search, ['companyName', 'companyEmail']))

export const companiesApiMock = {
  getByID: async (params: { orgID: string; companyOrgNumber: string }): Promise<Companies> =>
    delay(companyStore.getById(params.companyOrgNumber) ?? ({} as Companies)),
  update: async (payload: Partial<Companies>): Promise<Companies> => {
    const updated = payload.companyOrgNumber
      ? companyStore.update(payload.companyOrgNumber, payload)
      : undefined
    return delay(updated ?? ({} as Companies))
  },
  create: async (payload: CompanyPayload): Promise<Companies> => {
    const defaults: Companies = {
      orgID: MOCK_ORG_ID,
      companyOrgNumber: `${Date.now()}`,
      companyName: '',
      companyReference: '',
      companyEmail: '',
      companyNumber: 0,
      companyPhone: '',
      companyAddress: '',
      companyZipCode: '',
      companyAddressCity: '',
      companyCountry: '',
      createdAt: nowISO(),
      updatedAt: nowISO(),
    }
    const company: Companies = { ...defaults, ...payload }
    companyStore.insert(company)
    return delay(company)
  },
  list: async (params: CompaniesListParam): Promise<Companies[]> => delay(filterCompanies(params)),
  listCursor: async (params: CompaniesListParam): Promise<CursorPaginatedResponse<Companies>> =>
    delay(paginate(filterCompanies(params), params)),
}
